import { Link, useParams } from "react-router-dom";
import EventRunner from "./event-runner";
import { eventRunnerPath, parseEventPath } from "./event-path";
import { useVmetaEvents } from "./events.api";

const EventsTab = ({ canvasId }: { canvasId: string }) => {
  const params = useParams();
  const eventId = params.eventId;
  const { data, isLoading, error } = useVmetaEvents(canvasId, !eventId);

  if (eventId) {
    return (
      <EventRunner
        key={eventId}
        canvasId={canvasId}
        eventId={eventId}
        path={parseEventPath(params["*"])}
      />
    );
  }
  if (isLoading) {
    return <p className="p-4 text-sm text-gray-500">Loading event forms.</p>;
  }
  if (error) {
    return (
      <p className="p-4 text-sm text-gray-700">
        Event forms could not be loaded.
      </p>
    );
  }
  if (!data?.length) {
    return (
      <p className="p-4 text-sm text-gray-700">
        No event forms you can open on this canvas.
      </p>
    );
  }
  return (
    <ul className="divide-y divide-gray-100 p-4">
      {data.map(e => (
        <li key={e.id} className="py-2">
          <Link
            className="text-sm font-medium text-indigo-600 hover:underline"
            to={eventRunnerPath(canvasId, e.id)}>
            {e.name}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default EventsTab;
